import {combineReducers} from "redux";
import projectsReducer from './projects';
import bidsReducer from "./bids";
import notificationsReducer from "./notifications";
import reportsReducer from "./reports";
import rfisReducer from "./rfis";
import submittalsReducer from "./submittals";
import tasksReducer from "./tasks";
import dailyLogReducer from "./dailyLog";
import punchListReducer from "./punchList";
import profileReducer from "./profile";
import addressBookReducer from "./addressBook";
import employeesReducer from "./employees";
import uiReducer from "./ui";
import companiesReducer from "./companies";
import usersReducer from "./users";
import activityReducer from './activity';
import authReducer from './auth';
import {bidContactsReducer} from "./bidcontacts";
import {projectContactsReducer} from "./projectcontacts";
import filesReducer from "./files";
import commentsReducer from './comments';
import viewReducer from "./view";
import cacheReducer from "./cache";
import conversionReducer from "./conversion";
import photosReducer from "./photos";
import logosReducer from "./logos";

export function createReducer(initialState, handlers) {
  return function reducer(state = initialState, action) {
    if (handlers.hasOwnProperty(action.type)) {
      return handlers[action.type](state, action);
    } else {
      return state;
    }
  }
}

// const reducer = handleActions(reducerMap, initialState);
const appReducer = combineReducers({
  activity: activityReducer,
  addressbook: addressBookReducer,
  auth: authReducer,
  bidcontacts: bidContactsReducer,
  bids: bidsReducer,
  cache: cacheReducer,
  comments: commentsReducer,
  companies: companiesReducer,
  conversion: conversionReducer,
  dailylog: dailyLogReducer,
  employees: employeesReducer,
  files: filesReducer,
  logos: logosReducer,
  notifications: notificationsReducer,
  photos: photosReducer,
  profile: profileReducer,
  projectcontacts: projectContactsReducer,
  projects: projectsReducer,
  punchlist: punchListReducer,
  reports: reportsReducer,
  rfis: rfisReducer,
  submittals: submittalsReducer,
  tasks: tasksReducer,
  ui: uiReducer,
  users: usersReducer,
  view: viewReducer,
});


const RESET_APP = 'RESET_APP';
export const resetApp = () => ({ type: RESET_APP });

const rootReducer = (state, action) => {
  if (action.type === RESET_APP) {
    state = undefined;
  }
  return appReducer(state, action);
};

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js